import * as yup from 'yup';
import { IName } from '../../../common';

export const DoctorSchema = yup.object({
  subjectArea: yup.string().optional().nullable(),
  phoneNumber: yup.string().optional().nullable(),
  fax: yup.string().notRequired().nullable(),
  houseDoctor: yup.boolean().optional().nullable().default(false),
  city: yup.string().notRequired().nullable(),
  zipCode: yup.string().notRequired().nullable(),
  houseNumber: yup.string().notRequired().nullable(),
  mobilePhoneNumber: yup.string().notRequired().nullable(),
  street: yup.string().notRequired().nullable(),
  email: yup.string().notRequired().nullable(),
  praxis: yup.string().notRequired().nullable(),
  nursingHomeId: yup.string().notRequired().nullable(),
});

export interface IDoctor {
  subjectArea?: string;
  phoneNumber?: string;
  fax?: string;
  houseDoctor: boolean;
  name: IName;
  city?: string;
  zipCode?: string;
  houseNumber?: string;
  mobilePhoneNumber?: string;
  street?: string;
  email?: string;
  praxis?: string;
  nursingHomeId?: string;
}

export interface IDoctorWithId {
  id: string;
  subjectArea?: string;
  phoneNumber?: string;
  fax?: string;
  houseDoctor: boolean;
  name: IName;
  city?: string;
  zipCode?: string;
  houseNumber?: string;
  mobilePhoneNumber?: string;
  street?: string;
  email?: string;
  praxis?: string;
  nursingHomeId?: string;
}

export const UpdateDoctorSchema = yup
  .object({
    id: yup.string().required(),
  })
  .concat(DoctorSchema);

export interface IUpdateDoctor extends IDoctor {
  id: string;
}
